export default {
  get_certs: "certificate/getallcertificate",
  get_cert: "certificate/getcertificate/%s",
  post_cert: "certificate/createcertificate",
  edit_cert: "certificate/editcertificate",
  add_payment: "certificate/addpaytocertificate",
  upload_personal_image: "image/upload/Personal",
  upload_national_image: "image/upload/National",
  upload_payment_image: "image/upload/Payment",
  accept_certificate: "certificate/acceptCertificateByUser",
  reject_certificate: "certificate/cancelCertificateByUser",
  reset_password: "user/resetPassword",
};
